export function storeDetailsStepConfig({ country }) {
  const storeDetails = {
    storeName: `Klarna ${country} Swag Store`,
    website: 'http://klarna.com',
    email: 'support@email.com',
    goodsCategory: 'ADULT_SHOES_AND_CLOTHING',
    country,
  };

  const partialStoreDetails = {
    storeName: null,
    website: null,
    goodsCategory: 'ADULT_SHOES_AND_CLOTHING',
    email: null,
  };

  return {
    storeDetails: {
      value: storeDetails,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    partialStoreDetails: {
      value: partialStoreDetails,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
  };
}
